var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1041 0H4.89564C4.73454 0 4.60409 0.130454 4.60409 0.291551V9.21586L0.291551 9.21605C0.130458 9.21605 0 9.3465 0 9.5076V18.716C0 18.8771 0.130454 19.0076 0.291551 19.0076H18.7085C18.8695 19.0076 19 18.8771 19 18.716V9.49231C19 9.33122 18.8695 9.20076 18.7085 9.20076H14.3882L14.388 0.284344C14.388 0.123059 14.2653 0.000311249 14.1042 0.000311249L14.1041 0ZM8.2491 0.575584H10.743V2.66284L9.69935 1.61921C9.58432 1.50417 9.4078 1.50417 9.29257 1.61921L8.24894 2.66284L8.2491 0.575584ZM3.64482 9.78354H6.1464V11.8708L5.10277 10.8272C4.98774 10.7121 4.81122 10.7121 4.69599 10.8272L3.65237 11.8708L3.65256 9.78354H3.64482ZM9.20827 18.4163H0.575504V9.78354H3.06939L3.06958 12.5614C3.06958 12.6765 3.13856 12.784 3.24609 12.83C3.35361 12.8761 3.47636 12.853 3.56076 12.7686L4.88823 11.4411L6.21571 12.7686C6.26947 12.8223 6.34616 12.853 6.42285 12.853C6.4612 12.853 6.49955 12.8453 6.53038 12.83C6.6379 12.784 6.70689 12.6842 6.70689 12.5614V9.77599H9.20077V18.4162L9.20827 18.4163ZM5.17978 9.20835V0.575584H7.67366V3.35331C7.67366 3.46835 7.74265 3.57587 7.85017 3.62193C7.9577 3.66798 8.08044 3.64486 8.16484 3.56046L9.49231 2.23299L10.8198 3.56046C10.8735 3.61422 10.9502 3.64486 11.0269 3.64486C11.0653 3.64486 11.1036 3.63715 11.1345 3.62193C11.242 3.57587 11.311 3.47606 11.311 3.35331V0.575582H13.8048V9.20835L5.17978 9.20835ZM15.6387 12.8532C15.6771 12.8532 15.7154 12.8455 15.7463 12.8303C15.8538 12.7842 15.9228 12.6844 15.9228 12.5617V9.77623H18.4167V18.409H9.78389V9.78363H12.2778V12.5615C12.2778 12.6765 12.3468 12.7841 12.4543 12.8301C12.5618 12.8762 12.6846 12.8531 12.769 12.7687L14.0964 11.4412L15.4239 12.7687C15.4931 12.8224 15.5621 12.8531 15.6388 12.8531L15.6387 12.8532ZM15.3472 9.78374V11.871L14.3036 10.8274C14.1885 10.7123 14.012 10.7123 13.8968 10.8274L12.8532 11.871V9.78374H15.3472Z",
    fill: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.15335,
    y: 13.4678,
    width: 3.55177,
    height: 0.887942,
    rx: 0.443971,
    fill: "#222222",
    stroke: "#C4C4C4",
    strokeWidth: 0.19732
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3799,
    y: 13.4678,
    width: 3.55177,
    height: 0.887942,
    rx: 0.443971,
    fill: "#222222",
    stroke: "#C4C4C4",
    strokeWidth: 0.19732
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7471,
    y: 4.29202,
    width: 3.55177,
    height: 0.887942,
    rx: 0.443971,
    fill: "#222222",
    stroke: "#C4C4C4",
    strokeWidth: 0.19732
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombos);
export default __webpack_public_path__ + "static/media/Combos.83aa527a14e53453e7193ad9f01a4e7c.svg";
export { ForwardRef as ReactComponent };